import React, { ReactNode } from "react";

interface Props {
    children: ReactNode;
}

export function PanelFooter({ children }: Props) {
    return (
        <div className="shrink-0 flex items-center justify-end gap-2 border-t border-border-token -mx-6 -mb-6 px-6 py-4">
            {children}
        </div>
    );
}
